import { findUnits } from './helperUtility';
import { findStartDateTime, findFinishDateTime } from './timeUtility';

// eslint-disable-next-line import/prefer-default-export
export const parseCartItems = (items) => items.reduce((all, item) => {
  const reservationItem = {
    product_title: item.product_title,
    external_id: item.variant_id,
    quantity: findUnits(item),
    total_quantity: item.quantity,
    status: 'ok',
  };

  if (item.properties) {
    const { Resource, Location, _variant_id, _product_id, product, _resource, _resource_ids } = item.properties;
    if (Resource) reservationItem.resource_name = Resource;
    if (_resource && !Resource) reservationItem.resource_name = _resource;
    if (Location) reservationItem.location_name = Location;
    if (product && _product_id && _variant_id) reservationItem.external_id = _variant_id;
    if (product && _variant_id) reservationItem.variant_for_bond_id = _variant_id;
    if (_resource_ids && _resource_ids.length > 1) reservationItem.resource_ids = _resource_ids.split(', ');
  }

  let options = false;
  if (window.bta && window.bta.dateFormat) {
    options = {
      date: { format: window.bta.dateFormat },
      time: true,
    };
  }

  const start = findStartDateTime(item.properties, options);
  if (start) reservationItem.start = start;

  const finish = findFinishDateTime(item.properties, options);
  if (finish) reservationItem.finish = finish;

  all.push(reservationItem);

  return all;
}, []);
